import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalAxisState } from "./analytical-axis-state.model";
import { AnalyticalDistribution } from "./analytical-distribution.model";

/** État analytique d'un porteur : axes déclenchés (équilibre) + ventilations. */
export class AnalyticalVentilationState extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalVentilationState';

    private _axes!: AnalyticalAxisState[];
    private _distributions!: AnalyticalDistribution[];

    public get axes(): AnalyticalAxisState[] {
        return this._axes;
    }

    public set axes(value: any) {
        this._setValue('_axes', value, 'AnalyticalAxisState');
    }

    public get distributions(): AnalyticalDistribution[] {
        return this._distributions;
    }

    public set distributions(value: any) {
        this._setValue('_distributions', value, 'AnalyticalDistribution');
    }
}
